import React from 'react';
import PropTypes from 'prop-types';

import {
  Criterium,
  CriteriumCompetitors,
  CriteriumKeywordsCloud
} from '@hydra/common/criterium';
import { useReviewContext, usePdfTemplateContext } from '@hydra/common/context';

import hasCritData from '@hydra/utils/hasCritData';
import { getContrastedColor, getPriSecColors } from '@hydra/utils/colors';

export const KeywordsCloud = ({ criterium, competitors = [] }) => {
  const { isPdf } = useReviewContext();
  const { templateColors } = usePdfTemplateContext();

  const { primary, secondary } = isPdf
    ? templateColors
    : getPriSecColors();
  const color = getContrastedColor(primary);

  const { data, url } = criterium;

  const singleContent = <CriteriumKeywordsCloud keywords={data} color={color} />;
  let compContent;
  if (competitors.length > 0) {
    const compComponents = [
      { component: singleContent, url },
      ...competitors.map(({ criteria }, index) => {
        if (!hasCritData(criteria.keywords_cloud)) {
          return null;
        }
        const { data, url } = criteria.keywords_cloud;
        return {
          component: (
            <CriteriumKeywordsCloud
              keywords={data}
              color={secondary[index]}
            />
          ),
          url
        };
      })
    ];
    compContent = <CriteriumCompetitors competitors={compComponents} />;
  }

  return <Criterium criterium={criterium}>{compContent || singleContent}</Criterium>;
};

KeywordsCloud.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.arrayOf(
      PropTypes.shape({
        keyword: PropTypes.string.isRequired,
        amount: PropTypes.number.isRequired
      })
    )
  }),
  competitors: PropTypes.arrayOf(PropTypes.shape({
    criteria: PropTypes.shape({
      keywords_cloud: PropTypes.shape({
        url: PropTypes.string,
        data: PropTypes.arrayOf(
          PropTypes.shape({
            keyword: PropTypes.string.isRequired,
            amount: PropTypes.number.isRequired
          })
        )
      })
    })
  })),
  color: PropTypes.string
};

export default React.memo(KeywordsCloud);
